import Box from '@mui/material/Box'
import { Button, Stack, Typography } from '@mui/material'
import { EngineerAvatar } from '../Svgs'
import { AssignItem } from '../../models/Review'
import ProgressBarComponent from '../ProgressBarComponent'

interface AssignedEngineerProps {
  discipline: AssignItem | undefined
}

const AssignedEngineerComponent: React.FC<AssignedEngineerProps> = ({
  discipline,
}) => {
  return (
    <Stack sx={{ width: '100%' }} gap={'0.7rem'}>
      <Box display={'flex'} flexDirection={'column'} gap={'5px'}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <EngineerAvatar />
            <Typography
              sx={{
                color: '#06004A',
                fontSize: '18px',
                lineHeight: 'normal',
                fontWeight: 500,
              }}
            >
              {!!discipline ? discipline.user?.user_name : 'Engineer'}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        gap='0.5rem'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifuyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '10px',
            height: '10px',
            borderRadius: '10px',
            background: '#FF0000',
          }}
        ></Box>
        <Typography
          sx={{
            color: '#04002E',
            fontSize: '0.82rem',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          6 new alerts
        </Typography>
      </Box>
      <Box gap='0.7rem' display='flex' alignItems='flex-end'>
        <Box sx={{ display: 'flex', width: '74%' }}>
          <ProgressBarComponent
            completed={89}
            total={100}
            showPercentage={true}
            height='2rem'
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            width: '26%',
          }}
        >
          <Button
            variant='outlined'
            size='small'
            sx={{
              textTransform: 'capitalize',
              fontSize: '12px',
              borderRadius: '4px',
              minWidth: '110px',
              background: 'transparent',
              border: '1px solid #04002E',
              color: '#04002E',
            }}
          >
            Contact Engineer
          </Button>
          <Button
            variant='outlined'
            size='small'
            sx={{
              textTransform: 'capitalize',
              fontSize: '12px',
              borderRadius: '4px',
              minWidth: '110px',
              background: 'transparent',
              border: '1px solid #04002E',
              color: '#04002E',
            }}
          >
            Replace Role
          </Button>
        </Box>
      </Box>
    </Stack>
  )
}

export default AssignedEngineerComponent
